export default __webpack_public_path__ + "static/media/ambasadorp3big_thumb.0ef4217f.jpg";